<template>
  <div class="download-cover">
    <img src="../../view/authentication/images/img_kuang@2x.png" class="cover-img">
  </div>
</template>

<script>
export default {
  name: 'DownloadCover'
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.download-cover{
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,.75);
  .cover-img{
    display: block;
    width: 620px;
    height: 298px;
    margin: 42px auto;
  }
}
</style>